import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Autocomplete, TextField, MenuItem } from "@mui/material";

import {
  EventContainer,
  FormGrid,
  Card,
  CardTitle,
  InputGroup,
  InputLabel,
  Textarea,
  TagsSection,
  Tag,
  RadioButton,
  RadioGroup,
} from "./styles";

export default function DetalhesEvento({ eventoData, setEventoData }) {
  const locaisOriximina = [
    "Centro",
    "Cidade Nova",
    "Juruti Velho",
    "Bairro São Sebastião",
    "Santíssimo",
    "Bela Vista",
    "Rua 7 de Setembro",
    "Rua Marechal Rondon",
    "Aldeia",
  ];

  const tagColors = {
    Educação: "#6366F1",
    Esporte: "#6366F1",
    Cultura: "#A855F7",
    Saúde: "#10B981",
    Natureza: "#10B981",
    Treinamento: "#F59E0B",
    Lazer: "#9333EA66",
    Tecnologia: "#1D4ED8",
    IA: "#7E22CE",
  };

  function toggleTag(tag) {
    const newTags = eventoData.tags.includes(tag)
      ? eventoData.tags.filter((t) => t !== tag)
      : [...eventoData.tags, tag];
    setEventoData({ ...eventoData, tags: newTags });
  }

  // -------------------- CONTATOS ------------------------
  const contatos =
    eventoData.contatos && eventoData.contatos.length > 0
      ? eventoData.contatos
      : [
          {
            id: Date.now() + Math.random(),
            telefone: "",
            email: "",
            redeSocial: "",
          },
        ];

  if (!eventoData.contatos || eventoData.contatos.length === 0) {
    setTimeout(() => {
      setEventoData({ ...eventoData, contatos });
    }, 0);
  }

  const handleContatoChange = (id, field, value) => {
    const novos = (eventoData.contatos || []).map((c) =>
      c.id === id ? { ...c, [field]: value } : c
    );
    setEventoData({ ...eventoData, contatos: novos });
  };

  const handleAdicionarContato = () => {
    const novo = {
      id: Date.now() + Math.random(),
      telefone: "",
      email: "",
      redeSocial: "",
    };
    setEventoData({
      ...eventoData,
      contatos: [...(eventoData.contatos || []), novo],
    });
  };

  const handleRemoverContato = (id) => {
    const novos = (eventoData.contatos || []).filter((c) => c.id !== id);

    if (novos.length === 0) {
      const empty = {
        id: Date.now() + Math.random(),
        telefone: "",
        email: "",
        redeSocial: "",
      };
      setEventoData({ ...eventoData, contatos: [empty] });
    } else {
      setEventoData({ ...eventoData, contatos: novos });
    }
  };

  // -------------------- CONTEÚDOS DO EVENTO ------------------------
  const conteudos =
    eventoData.conteudos && eventoData.conteudos.length > 0
      ? eventoData.conteudos
      : [{ titulo: "", itens: [""] }];

  if (!eventoData.conteudos || eventoData.conteudos.length === 0) {
    setTimeout(() => {
      setEventoData({ ...eventoData, conteudos });
    }, 0);
  }

  const updateTitulo = (index, value) => {
    const novos = [...eventoData.conteudos];
    novos[index].titulo = value;
    setEventoData({ ...eventoData, conteudos: novos });
  };

  const updateItem = (cIndex, iIndex, value) => {
    const novos = [...eventoData.conteudos];
    novos[cIndex].itens[iIndex] = value;
    setEventoData({ ...eventoData, conteudos: novos });
  };

  const addItem = (cIndex) => {
    const novos = [...eventoData.conteudos];
    novos[cIndex].itens.push("");
    setEventoData({ ...eventoData, conteudos: novos });
  };

  const removeItem = (cIndex, iIndex) => {
    const novos = [...eventoData.conteudos];
    novos[cIndex].itens.splice(iIndex, 1);
    if (novos[cIndex].itens.length === 0) {
      novos[cIndex].itens = [""];
    }
    setEventoData({ ...eventoData, conteudos: novos });
  };

  const addBloco = () => {
    setEventoData({
      ...eventoData,
      conteudos: [...eventoData.conteudos, { titulo: "", itens: [""] }],
    });
  };

  const removerBloco = (index) => {
    const novos = eventoData.conteudos.filter((_, i) => i !== index);
    setEventoData({
      ...eventoData,
      conteudos: novos.length ? novos : [{ titulo: "", itens: [""] }],
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <EventContainer>
        <FormGrid>
          {/* ----------------- CARD DETALHES PRINCIPAIS ------------------ */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Detalhes do Evento</CardTitle>

            {/* Título */}
            <InputGroup>
              <InputLabel>Título do Evento *</InputLabel>
              <TextField
                placeholder="Insira o título do evento"
                fullWidth
                value={eventoData.titulo}
                onChange={(e) =>
                  setEventoData({ ...eventoData, titulo: e.target.value })
                }
              />
            </InputGroup>

            {/* Descrição */}
            <InputGroup>
              <InputLabel>Descrição *</InputLabel>
              <Textarea
                placeholder="Descreva o evento..."
                value={eventoData.descricao}
                onChange={(e) =>
                  setEventoData({ ...eventoData, descricao: e.target.value })
                }
              />
            </InputGroup>

            {/* -------------------- ACESSO -------------------- */}
<InputGroup>
  <CardTitle>Acesso do evento</CardTitle>

  <RadioGroup>
    <RadioButton>
      <input
        type="radio"
        checked={eventoData.acesso === "Público"}
        onChange={() =>
          setEventoData({ ...eventoData, acesso: "Público" })
        }
      />
      <label>Público</label>
    </RadioButton>

    <RadioButton>
      <input
        type="radio"
        checked={eventoData.acesso === "Privado"}
        onChange={() =>
          setEventoData({ ...eventoData, acesso: "Privado" })
        }
      />
      <label>
        Privado <small>(Vagas limitadas)</small>
      </label>
    </RadioButton>
  </RadioGroup>

  {/* -------------------- VAGAS (só se privado) -------------------- */}
  {eventoData.acesso === "Privado" && (
    <InputGroup style={{ width: "150px", marginTop: "20px" }}>
      <InputLabel>Número de vagas *</InputLabel>
      <TextField
        type="number"
        placeholder="Ex: 50"
        value={eventoData.vagas}
        onChange={(e) =>
          setEventoData({ ...eventoData, vagas: e.target.value })
        }
      />
    </InputGroup>
  )}
</InputGroup>


            {/* Status */}
            <FormGrid columns="2" style={{ marginTop: "20px" }}>
              <InputGroup>
                <InputLabel>Status do Evento</InputLabel>
                <TextField
                  select
                  fullWidth
                  value={eventoData.status || "Upcoming"}
                  onChange={(e) =>
                    setEventoData({ ...eventoData, status: e.target.value })
                  }
                >
                  <MenuItem value="Upcoming">Próximo</MenuItem>
                  <MenuItem value="Ongoing">Em andamento</MenuItem>
                  <MenuItem value="Completed">Finalizado</MenuItem>
                  <MenuItem value="Canceled">Cancelado</MenuItem>
                </TextField>
              </InputGroup>

              {/* XP */}
              <InputGroup>
                <InputLabel>XP do Evento *</InputLabel>
                <TextField
                  type="number"
                  inputProps={{ min: 0 }}
                  placeholder="Ex: 50"
                  value={eventoData.xp}
                  onChange={(e) =>
                    setEventoData({
                      ...eventoData,
                      xp: Number(e.target.value),
                    })
                  }
                  fullWidth
                />
                <small style={{ color: "#64748b" }}>
                  XP concedido ao participar
                </small>
              </InputGroup>
            </FormGrid>

            {/* Destacado */}
            <InputGroup style={{ marginTop: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input
                  type="checkbox"
                  checked={eventoData.destacado}
                  onChange={(e) =>
                    setEventoData({ ...eventoData, destacado: e.target.checked })
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span>Evento destacado</span>
              </label>
              <small style={{ color: "#64748b" }}>
                Marque para exibir este evento em destaque na página inicial.
              </small>
            </InputGroup>
          </Card>

          {/* ------------------- TAGS + DATA + HORA + LOCAL + ORGANIZADOR ------------------- */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <InputGroup>
              <InputLabel>Selecione as tags do evento</InputLabel>
              <TagsSection>
                {Object.keys(tagColors).map((tag) => {
                  const isActive = eventoData.tags.includes(tag);
                  return (
                    <Tag
                      key={tag}
                      style={{
                        backgroundColor: isActive ? tagColors[tag] : "#ebeef2",
                        color: isActive ? "#fff" : "#566474",
                      }}
                      onClick={() => toggleTag(tag)}
                    >
                      {tag}
                    </Tag>
                  );
                })}
              </TagsSection>
            </InputGroup>

            <FormGrid columns="2">
              {/* Data */}
              <InputGroup>
                <InputLabel>Data *</InputLabel>
                <DatePicker
                  value={eventoData.data}
                  onChange={(date) =>
                    setEventoData({ ...eventoData, data: date })
                  }
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                />
              </InputGroup>

              {/* Hora */}
              <InputGroup>
                <InputLabel>Hora *</InputLabel>
                <TimePicker
                  value={eventoData.hora}
                  onChange={(time) =>
                    setEventoData({ ...eventoData, hora: time })
                  }
                  sx={{ width: "100%" }}
                />
              </InputGroup>

              {/* Local */}
              <InputGroup>
                <InputLabel>Local *</InputLabel>
                <Autocomplete
                  freeSolo
                  options={locaisOriximina}
                  inputValue={eventoData.local}
                  onInputChange={(e, newValue) =>
                    setEventoData({ ...eventoData, local: newValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Escolha ou digite o local"
                    />
                  )}
                />
              </InputGroup>

              {/* Organizador */}
              <InputGroup>
                <InputLabel>Organizador *</InputLabel>
                <TextField
                  placeholder="Nome da organização, pessoa ou grupo"
                  fullWidth
                  value={eventoData.organizador}
                  onChange={(e) =>
                    setEventoData({
                      ...eventoData,
                      organizador: e.target.value,
                    })
                  }
                />
              </InputGroup>
            </FormGrid>
          </Card>

          {/* ---------------------- CONTATOS ---------------------- */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Contatos do Evento</CardTitle>

            {(eventoData.contatos || []).map((contato) => (
              <div
                key={contato.id}
                style={{
                  display: "flex",
                  gap: "10px",
                  marginBottom: "12px",
                  alignItems: "flex-start",
                }}
              >
                <TextField
                  label="Telefone"
                  fullWidth
                  value={contato.telefone}
                  onChange={(e) =>
                    handleContatoChange(contato.id, "telefone", e.target.value)
                  }
                />

                <TextField
                  label="Email"
                  fullWidth
                  value={contato.email}
                  onChange={(e) =>
                    handleContatoChange(contato.id, "email", e.target.value)
                  }
                />

                <TextField
                  label="Rede Social (link)"
                  fullWidth
                  value={contato.redeSocial}
                  onChange={(e) =>
                    handleContatoChange(contato.id, "redeSocial", e.target.value)
                  }
                />

                {(eventoData.contatos || []).length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoverContato(contato.id)}
                    style={{
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      height: "fit-content",
                    }}
                  >
                    Remover
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={handleAdicionarContato}
              style={{
                marginTop: "10px",
                padding: "10px 14px",
                borderRadius: "8px",
                border: "none",
                background: "#2563eb",
                color: "white",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              Adicionar contato
            </button>
          </Card>

          {/* ---------------------- CONTEÚDOS DO EVENTO ---------------------- */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Conteúdos do Evento</CardTitle>

            {conteudos.map((conteudo, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "16px",
                  marginBottom: "20px",
                }}
              >
                <TextField
                  label="Título do conteúdo"
                  fullWidth
                  value={conteudo.titulo}
                  onChange={(e) => updateTitulo(index, e.target.value)}
                  style={{ marginBottom: "12px" }}
                />

                <strong>Itens</strong>
                {conteudo.itens.map((item, iIndex) => (
                  <div
                    key={iIndex}
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <TextField
                      placeholder={`Item ${iIndex + 1}`}
                      fullWidth
                      value={item}
                      onChange={(e) =>
                        updateItem(index, iIndex, e.target.value)
                      }
                    />

                    <button
                      type="button"
                      onClick={() => removeItem(index, iIndex)}
                      style={{
                        background: "#dc2626",
                        color: "#fff",
                        border: "none",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      X
                    </button>
                  </div>
                ))}

                <button
                  type="button"
                  onClick={() => addItem(index)}
                  style={{
                    padding: "8px 12px",
                    background: "#2563eb",
                    borderRadius: "6px",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                    marginBottom: "12px",
                  }}
                >
                  + Adicionar item
                </button>

                {conteudos.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removerBloco(index)}
                    style={{
                      padding: "8px 12px",
                      background: "#dc2626",
                      borderRadius: "6px",
                      color: "#fff",
                      border: "none",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                  >
                    Remover bloco
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={addBloco}
              style={{
                padding: "10px 14px",
                background: "#059669",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              + Adicionar novo conteúdo
            </button>
          </Card>
        </FormGrid>
      </EventContainer>
    </LocalizationProvider>
  );
}
